// Determine environment from API URL or fall back to process.env.REACT_APP_ENV
const determineEnvironment = () => {
  const devApiDomain = process.env.REACT_APP_DEV_API_DOMAIN || '';
  if (process.env.REACT_APP_API_URL && devApiDomain && process.env.REACT_APP_API_URL.includes(devApiDomain)) {
    return 'development';
  }
  return process.env.REACT_APP_ENV;
};

// Export environment variables
export const ENV = determineEnvironment();
export const API_URL = process.env.REACT_APP_API_URL;
export const SOURCE_URL = process.env.REACT_APP_SOURCE_URL;
export const Article_API_TOKEN = process.env.REACT_APP_ARTICLE_API_TOKEN;
export const GetStarted_API_TOKEN = process.env.REACT_APP_GET_STARTED_API_TOKEN;
export const Minisite_API_TOKEN = process.env.REACT_APP_MINISITE_API_TOKEN;
export const ChannelOverview_API_TOKEN = process.env.REACT_APP_CHANNEL_OVERVIEW_API_TOKEN;
export const Blog_API_TOKEN = process.env.REACT_APP_BLOG_API_TOKEN;
export const Media_Base_URL = process.env.REACT_APP_MEDIA_BASE_URL;
export const Support_API_TOKEN = process.env.REACT_APP_SUPPORT_API_TOKEN;

// Log current environment configuration for debugging
// console.log('Current environment:', ENV);
// console.log('API URL:', API_URL);